// TODO: add a data attr to the quartz template to make this less brittle
export const CURRENT_APP_SELECTORS = ['.app', '.page', '#forms-application'];
const getHubspotPageElement = () => {
  for (const appSelctor of CURRENT_APP_SELECTORS) {
    const app = document.body.querySelector(appSelctor);
    if (app != null) {
      return app;
    }
  }
  return null;
};
export default getHubspotPageElement;